"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DraggableInsightListItemWrapper = exports.DraggableInsightListItemBody = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var DraggableInsightListItem_1 = require("../../../dragAndDrop/draggableWidget/DraggableInsightListItem");
exports.DraggableInsightListItemBody = function (props) {
    var className = props.className;
    return (react_1.default.createElement("div", { className: className },
        react_1.default.createElement(sdk_ui_kit_1.InsightListItem, tslib_1.__assign({}, props))));
};
exports.DraggableInsightListItemWrapper = function (props) {
    var WrapInsightListItemWithDragComponent = props.WrapInsightListItemWithDragComponent, className = props.className, isLocked = props.isLocked, title = props.title, description = props.description, showDescriptionPanel = props.showDescriptionPanel, type = props.type, updated = props.updated, insight = props.insight, onDescriptionPanelOpen = props.onDescriptionPanelOpen;
    return (react_1.default.createElement(DraggableInsightListItem_1.DraggableInsightListItem, { WrapInsightListItemWithDragComponent: WrapInsightListItemWithDragComponent, ListItemComponent: exports.DraggableInsightListItemBody, listItemComponentProps: {
            className: className,
            isLocked: isLocked,
            title: title,
            description: description,
            type: type,
            updated: updated,
            showDescriptionPanel: showDescriptionPanel,
            onDescriptionPanelOpen: onDescriptionPanelOpen,
        }, insight: insight }));
};
//# sourceMappingURL=DraggableInsightListItemWrapper.js.map